import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle, sectionTitleStyle, sectionTitleText } from "../cardStyles";

interface WinbackCardProps {
  onCall: () => void;
}

const WinbackCard = ({ onCall }: WinbackCardProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  return (
    <div style={{ ...cardStyle, border: "2px solid #c7d2fe" }}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="Heart2Icon" size="XS" color="#4f46e5" />
        <h2 style={sectionTitleText}>
          {translate("newDashboard.redesign.winbackTitle")}
        </h2>
      </div>
      <p style={{ fontSize: 14, color: "#4b5563", margin: "8px 0 20px" }}>
        {translate("newDashboard.redesign.winbackDesc")}
      </p>
      <ButtonDS
        label={translate("newDashboard.redesign.winbackCta")}
        buttonType="primary"
        size="40"
        onClick={onCall}
      />
    </div>
  );
};

export default WinbackCard;
